import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { AuthFacade } from '@mitsubishi/core';

import { Store } from '@ngxs/store';

import { ConnectedUser } from './connected-users.model';
import { ProjectConnectedUsersState } from './connected-users.state';

@Injectable({
  providedIn: 'root',
})
export class ConnectedUsersFacade {
  allConnectedUsers$ = this.connectedUsersState.entitiesArray$;
  /**
   * Contains connected users to the project excluding the current user
   * */
  connectedUsers$ = combineLatest([this.allConnectedUsers$, this.authFacade.userInfo$]).pipe(
    map(([users, currentUser]) => {
      return users.filter(u => u.id !== currentUser?.username);
    })
  );

  constructor(
    private readonly store: Store,
    private readonly connectedUsersState: ProjectConnectedUsersState,
    private authFacade: AuthFacade
  ) {}

  connectUserToProject(user: ConnectedUser) {
    this.connectedUsersState.connectUser(user);
  }

  disconnectUserFromProject(userId: string) {
    this.connectedUsersState.disconnectUser(userId);
  }
}
